module.exports = __webpack_public_path__ + "static/media/digiart.af528128.png";